<script>
import AppHeader from '@/components/shared/AppHeader';
import AppFooter from '@/components/shared/AppFooterNonHome.vue';
import axios from 'axios';

export default {
  name: 'FindSong',
  components: {
    AppHeader,
    AppFooter,
  },
  data() {
    return {
      minDate: '2021-03-28',
      data: [],
      filteredData: [],
      paginatedData: [],
      currentPage: 1,
      customPage: 1,
      pageSize: 15,
      filters: {
        date: '',
        title: '',
        artist: ''
      }
    };
  },
  computed: {
    totalPages() {
      return Math.ceil(this.filteredData.length / this.pageSize);
    }
  },
  async created() {
    const sheetId = '1gnaea7d9v0iytISWJXHLCNsr_zObx1C2fLv1DaMksR4';
    const sheetName = 'Listen'; // Nama tab pada Google Sheets
    const apiKey = 'AIzaSyAWtgIDV5mt3A9ZjKu-gMsrAZhuTVPvYj8';

    try {
      const response = await axios.get(
        `https://sheets.googleapis.com/v4/spreadsheets/${sheetId}/values/${sheetName}?key=${apiKey}`
      );
      this.data = response.data.values
      this.filteredData = this.data;
      this.updatePagination();
    } catch (error) {
      console.error('Error fetching Google Sheet data:', error);
    }
  },
  methods: {
    formatTanggalIndo(dateString) {
      const date = new Date(dateString);
      return new Intl.DateTimeFormat('id-ID', { day: 'numeric', month: 'long', year: 'numeric' }).format(date);
    },
    applyFilters() {
      this.filteredData = this.data.filter(row => {
        const dateMatch = !this.filters.date || row[0] === this.formatTanggalIndo(this.filters.date);
        const searchMatch = !this.filters.search ||
          row[1].toLowerCase().includes(this.filters.search.toLowerCase()) ||
          row[2].toLowerCase().includes(this.filters.search.toLowerCase());
        return dateMatch && searchMatch;
      });
      this.currentPage = 1;
      this.updatePagination();
    },
    updatePagination() {
      const start = (this.currentPage - 1) * this.pageSize;
      const end = start + this.pageSize;
      this.paginatedData = this.filteredData.slice(start, end);
    },
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
        this.updatePagination();
      }
    },
    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        this.updatePagination();
      }
    },
    goToFirstPage() {
      this.currentPage = 1;
      this.updatePagination();
    },
    goToLastPage() {
      this.currentPage = this.totalPages;
      this.updatePagination();
    },
    goToCustomPage() {
      if (this.customPage >= 1 && this.customPage <= this.totalPages) {
        this.currentPage = this.customPage;
        this.updatePagination();
      } else {
        this.customPage = this.currentPage; // Reset jika input salah
      }
    }
  },
  watch: {
    currentPage(value) {
      this.customPage = value; // Update customPage saat currentPage berubah
    }
  }
};
</script>

<template>

  <!-- App Header -->
  <AppHeader class="items-center mb-24 px-10" />

  <!-- Card Container Start -->
  <div class="container mx-auto">
    <div class="text-center border-b border-primary-light
					dark:border-secondary-dark">
      <p
        class="font-general-semibold text-2xl sm:text-5xl font-semibold text-ternary-dark dark:text-ternary-light mb-4">
        What Song Oniel Play?
      </p>
      <h3 class="font-general-regular
					text-center text-secondary-dark
					dark:text-ternary-light
					text-md
					sm:text-xl
					font-normal
					mb-4
				">
        Cek apakah Oniel pernah memutar lagu ini atau belum?
      </h3>
    </div>
    <!-- Fitur Cari -->
    <!-- Percobaan -->
    <div class="mx-auto max-w-screen-xl px-4 lg:px-12 mt-10">
      <p class="font-general-regular
					text-justify text-secondary-dark
					dark:text-ternary-light
					text-xs
					sm:text-sm
					font-normal
					my-4
				">
        Seluruh data terkait rekap <b>#WhatSongOnielPlay</b> dan rekap <b>#OnieLand</b> dapat digunakan secara bebas
        tanpa
        batasan hak cipta.
        Silakan gunakan, bagikan, atau modifikasi sesuai kebutuhan Anda. Kami sangat mengapresiasi jika anda memberikan
        kredit kepada kami pada project atau karya yang anda buat menggunakan data tersebut
      </p>
      <!-- Start coding here -->
      <div class="bg-white dark:bg-gray-800 relative shadow-md sm:rounded-lg overflow-hidden">
        <div class="flex flex-col md:flex-row items-center justify-between space-y-3 md:space-y-0 md:space-x-4 p-4">
          <div class="w-full md:w-1/2">
            <form class="flex items-center">
              <div class="relative w-full mr-1">
                <div class="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                  <svg aria-hidden="true" class="w-5 h-5 text-gray-500 dark:text-gray-400" fill="currentColor"
                    viewbox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd"
                      d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
                      clip-rule="evenodd" />
                  </svg>
                </div>
                <input
                  class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-500 focus:border-primary-500 block w-full pl-10 p-2 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
                  v-model="filters.search" @input="applyFilters" type="text" placeholder=" Cari berdasarkan judul lagu/artis">
              </div>
            </form>
          </div>
          <div
            class="w-full md:w-auto flex flex-col md:flex-row space-y-2 md:space-y-0 items-stretch md:items-center justify-end md:space-x-3 flex-shrink-0">
            <div class="flex items-center space-x-3 w-full md:w-auto">
              <input
                class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-500 focus:border-primary-500 block w-full pl-10 p-2 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
                type="date" v-model="filters.date" :min="minDate" @input="applyFilters" />
            </div>
          </div>
        </div>
        <div class="overflow-x-auto">
          <table class="w-full text-sm text-left text-gray-500 dark:text-gray-400">
            <thead class="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
              <tr>
                <th scope="col" class="px-4 py-3">Title Song</th>
                <th scope="col" class="px-4 py-3">Artist</th>
                <th scope="col" class="px-4 py-3">Platform</th>
                <th scope="col" class="px-4 py-3">Live Date</th>
                <th scope="col" class="px-4 py-3"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, index) in paginatedData" :key="index" class="border-b dark:border-gray-700">
                <td class="px-4 py-3">{{ row[1] }}</td>
                <td class="px-4 py-3">{{ row[2] }}</td>
                <td class="px-4 py-3">{{ row[3] }}</td>
                <td class="px-4 py-3">{{ row[0] }}</td>
                <td class="px-2 py-3">
                  <a v-if="row[4]" :href="row[4]" target="_blank" rel="noopener noreferrer" class="inline-flex items-center justify-center text-green-500 hover:text-green-600 dark:text-green-400 dark:hover:text-green-300 transition-colors">
                    <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                      <path xmlns="http://www.w3.org/2000/svg" fill="#1ED760" fill-rule="evenodd" d="M19.0983701,10.6382791 C15.230178,8.34118115 8.85003755,8.12986439 5.15729493,9.25058527 C4.56433588,9.43062856 3.93727638,9.09580812 3.75758647,8.50284907 C3.57789655,7.90953664 3.91236362,7.28283051 4.50585273,7.10261054 C8.74455585,5.81598127 15.7909802,6.06440214 20.2440037,8.70780512 C20.7774195,9.02442687 20.9525156,9.71332656 20.6362472,10.2456822 C20.3198021,10.779098 19.6305491,10.9549008 19.0983701,10.6382791 M18.971686,14.0407262 C18.7004726,14.4810283 18.1246521,14.6190203 17.6848801,14.3486903 C14.4600027,12.3664473 9.54264764,11.792217 5.72728477,12.9503953 C5.23256328,13.0998719 4.70992535,12.8208843 4.55974204,12.3270462 C4.41061884,11.8323247 4.68978312,11.3107469 5.18362118,11.1602103 C9.5419409,9.83771368 14.9600247,10.4782013 18.6638986,12.7544503 C19.1036707,13.0253103 19.242016,13.6013075 18.971686,14.0407262 M17.5034233,17.308185 C17.2876894,17.6617342 16.827245,17.7725165 16.4749326,17.5571359 C13.6571403,15.8347984 10.1101639,15.4459119 5.93312425,16.4000177 C5.53063298,16.4922479 5.12937851,16.2399399 5.03767834,15.8376253 C4.94544812,15.4351341 5.19669597,15.0338796 5.60024736,14.9420027 C10.1712973,13.8970803 14.0923186,14.3467468 17.2551791,16.2796943 C17.6078449,16.4948982 17.7189805,16.9556959 17.5034233,17.308185 M12,0 C5.37267547,0 0,5.37249879 0,11.9998233 C0,18.6278546 5.37267547,24 12,24 C18.6275012,24 24,18.6278546 24,11.9998233 C24,5.37249879 18.6275012,0 12,0"/>
                    </svg>
                  </a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <nav class="flex flex-col md:flex-row justify-between items-end md:items-center space-y-3 md:space-y-0 p-4"
          aria-label="Table navigation">
          <ul class="inline-flex items-stretch -space-x-px">
            <li>
              <button @click="goToFirstPage" :disabled="currentPage === totalPages"
                class="flex items-center justify-center h-full py-1.5 px-3 ml-0 text-gray-500 bg-white rounded-l-lg border border-gray-300 hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white">
                <span class="sr-only">Previous</span>
                <svg class="w-5 h-5" aria-hidden="true" fill="currentColor" viewBox="0 0 1024 1024" version="1.1"
                  xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M785.493333 707.84L589.653333 512l195.84-195.84L725.333333 256 469.333333 512l256 256zM256 256h85.333333v512h-85.333333z" />
                </svg>
              </button>
            </li>
            <li>
              <button @click="prevPage" :disabled="currentPage === 1"
                class="flex items-center justify-center h-full py-1.5 px-3 ml-0 text-gray-500 bg-white border border-gray-300 hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white">
                <span class="sr-only">Previous</span>
                <svg class="w-5 h-5" aria-hidden="true" fill="currentColor" viewBox="0 0 1024 1024" version="1.1"
                  xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M657.706667 316.373333L597.333333 256 341.333333 512l256 256 60.373334-60.373333L462.08 512z" />
                </svg>
              </button>
            </li>
            <li>
              <span class="px-3 text-black dark:text-white">Page <input type="number"
                  class="w-12 bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-500 focus:border-primary-500 p-2 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
                  v-model="customPage" @change="goToCustomPage" /> of {{ totalPages }}</span>
            </li>
            <li>
              <button @click="nextPage" :disabled="currentPage === totalPages"
                class="flex items-center justify-center h-full py-1.5 px-3 leading-tight text-gray-500 bg-white border border-gray-300 hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white">
                <span class="sr-only">Previous</span>
                <svg class="w-5 h-5" aria-hidden="true" fill="currentColor" viewBox="0 0 1024 1024" version="1.1"
                  xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M426.666667 256l-60.373334 60.373333L561.92 512l-195.626667 195.626667L426.666667 768l256-256z" />
                </svg>
              </button>
            </li>
            <li>
              <button @click="goToLastPage" :disabled="currentPage === totalPages"
                class="flex items-center justify-center h-full py-1.5 px-3 leading-tight text-gray-500 bg-white rounded-r-lg border border-gray-300 hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white">
                <span class="sr-only">Previous</span>
                <svg class="w-5 h-5" aria-hidden="true" fill="currentColor" viewBox="0 0 1024 1024" version="1.1"
                  xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M238.506667 316.16L434.346667 512l-195.84 195.84L298.666667 768l256-256-256-256zM682.666667 256h85.333333v512h-85.333333z" />
                </svg>
              </button>
            </li>
          </ul>
        </nav>
      </div>
    </div>



    <AppFooter />
  </div>
</template>

<style scoped></style>